<template>
  <div>
    <ag-grid-vue
    :style="'width:' + width + ';' + 'height:' + height + ';'"
        class="ag-theme-alpine"
        rowSelection="multiple"
        :animateRows="true"
        :pagination="true"
        :columnDefs="columns"
        :rowData="rows"
        :enableFilter="filtering"
        @grid-ready="onGridReady"
        @first-data-rendered="firstDataRendered"
        :rowHeight="rowHeight"
        :enableCellTextSelection="true"
    />
      <div slot="deleted" slot-scope="props">
        <mdb-icon
          v-if="props.rowData.deleted === 1"
          icon="trash"
          size="2x"
          class="red-text"
        />
      </div>
      <div slot="control-slot" slot-scope="props">
        <mdb-btn-group vertical>
          <mdb-btn
            v-if="button1 !== null"
            @click="editContent(props.rowData)"
            color="blue"
            size="sm"
            style="width: 130px"
            >{{ button1 }}</mdb-btn
          >
          <mdb-btn
            v-if="button2 !== null"
            @click="deleteContent(props.rowData.id)"
            color="aqua"
            size="sm"
            style="width: 130px"
            >{{ button2 }}</mdb-btn
          >
        </mdb-btn-group>
      </div>
    <SmallModal
      :modal-show="deleteModal"
      :title="$t('delete_modal_title')"
      :description="$t('delete_modal_description')"
      :buttontext="$t('delete_modal_buttontext')"
      v-on:modal-cancelled="deleteCancelled"
      v-on:modal-ok="deleteContentConfirmed"
    />
  </div>
</template>

<script>
import { mdbIcon, mdbBtn, mdbBtnGroup } from "mdbvue";
import SmallModal from "@/components/SmallModal.vue";
import { AgGridVue } from "ag-grid-vue";
import SimpleButtonGroup from "./SimpleButtonGroup.vue";
export default {
  name: "DataTableSimple",
  components: {
    AgGridVue,
    SmallModal,
    mdbIcon,
    mdbBtn,
    mdbBtnGroup,
    // eslint-disable-next-line vue/no-unused-components
    SimpleButtonGroup,
  },
  props: {
    width: String,
    height: String,
    columns: Array,
    buttonList: Array,
    rows: Array,
    autoSizeList: Array,
    rowHeight: {
      type: Number,
      default: 80,
    },
  },
  methods: {
    deleteCancelled() {
      this.deleteModal = false;
      this.deletingBenefit = 0;
    },
    editContent(rowData) {
      this.$emit("edit-content", rowData);
    },
    deleteContent(id) {
      this.deletingBenefit = id;
      this.deleteModal = true;
    },
    deleteContentConfirmed() {
      this.$emit("delete-content", this.deletingBenefit);
      this.deletingBenefit = 0;
      this.deleteModal = false;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      if (this.columns.find(element => element.field === 'action'))
        this.columns.splice(-1, 1);
      this.columns.push({
          headerName: "Toiminto",
          field: "action",
          pinned: "right",
          cellRenderer: "SimpleButtonGroup",
          cellRendererParams: {
            buttons: this.buttonList,
            clicked: function(id, button) {
              switch (button) {
                case 1:
                  this.$emit(
                    "pressed-button1",
                    this.rows.find((element) => element.id === id)
                  );
                  break;
                case 2:
                  this.$emit(
                    "pressed-button2",
                    this.rows.find((element) => element.id === id)
                  );
                  break;
                case 3:
                  this.$emit(
                    "pressed-button3",
                    this.rows.find((element) => element === id)
                  );
                  break;
              }
            }.bind(this),
          },
        });
    },
    firstDataRendered() {
        this.gridColumnApi.autoSizeAllColumns();
        //use if future need to resize only certain rows
        //this.gridColumnApi.autoSizeColumns(this.autoSizeList);
    },
  },
  data() {
    return {
      deletingBenefit: 0,
      deleteModal: false,
    };
  },
  mounted() {},
};
</script>
